import React, { Fragment, ReactElement, useEffect } from "react";
import { useHistory } from "react-router-dom";
import exclamation from '../../../assets/images/exclamation.svg';
import home from '../../../assets/images/home.svg';
import { getAccessToken, getStoreCode, getStoreInformation, getUser } from "../../../core/localstorage-data";
import { useAppDispatch } from "../../../redux/hooks";
import { fetchOrder } from "../../../redux/orderSlice";
import { HOME_ROUTE_PATH } from "../../../routes/route-constants";

const InvalidOrder = (): ReactElement => {
    const navigate = useHistory();
    const dispatch = useAppDispatch();
    const accessToken = getAccessToken();
    const storeCode = `0${getStoreInformation().store_code}`;
    const card_number = getUser().cardNumber;
    const storeId = getStoreCode();
    const buttonHandler = () => {
        navigate.push(HOME_ROUTE_PATH);
    };

    useEffect(() => {
        const parameters = {
            accessToken: accessToken,
            payload: {
                storeCode: storeCode,
                cardNumber: card_number,
                storeKeyId: storeId,
            },
        };
        dispatch(fetchOrder(parameters));
    }, []);

    return (
        <Fragment>
            <div className="container mx-auto z-10 p-4 bg-color">
                <div className="w-auto ">
                    <div className=" grid place-items-center">
                        <img src={exclamation} />
                    </div>
                    <div className="flex justify-center items-center">
                        <div className="text-big font-roboto font-light">
                            Purchase Error
                        </div>
                    </div>
                    <div className="flex justify-center items-center mb-2">
                        <div className="mt-2 grid text-center text-black text-opacity-50">
                            Payment was already initiated for the order, you cannot pay again. Please track the order from order history.
                        </div>
                    </div>
                    <div className="text-left">
                        <div className="font-roboto shadow-max p-4">
                            <div className="font-medium text-small mb-4">
                                Instructions to proceed
                            </div>
                            <div className="text-small mb-1">1. Go to Homepage</div>
                            <div className="text-small mb-1">
                                2. Click menu, go to All orders.
                            </div>
                            <div className="text-small mb-1">
                                3. Check others order tab.
                            </div>
                        </div>
                    </div>
                    <div className="mt-6">
                        <div className="flex justify-between">
                            <button
                                className={`text-white h-12 px-3 w-full rounded-radius10 border-solid border border-gray-400 grid place-items-center focus:outline-none text-center font-medium                secondary normal`}
                                onClick={buttonHandler}>
                                <div className="flex">
                                    <div>
                                        <img src={home} />
                                    </div>

                                    <div className="ml-2">
                                        {' '}
                                        <span className="text-roboto text-black">Home</span>
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default InvalidOrder;
